import {
  BaseTextFieldProps,
  FormControl,
  InputBaseProps,
  InputLabel,
  Typography,
} from "@material-ui/core"
import FormikInput from "common/bit/form/FormikInput"
import { Field, useField } from "formik"
import styled from "styled-components"

const Styled = {
  Field: styled(Field)<{ $center?: boolean }>`
    width: 100%;
    .MuiFormHelperText-root {
      font-size: 12px;
    }
    .MuiFormHelperText-root.Mui-error {
      ${(p) => (p.$center ? `text-align: center;` : ``)}
    }
    input {
      ${(p) => (p.$center ? `text-align: center;` : ``)}
    }
  `,
  FormControl: styled(FormControl)``,
  FieldWrapper: styled.div<{ $marginTop: number }>`
    margin-top: ${(p) => {
      if (p?.$marginTop === 0) return "0px"
      if (p?.$marginTop) return p.$marginTop + "px"
      return "22px"
    }};
  `,
  LabelWrapper: styled.div`
    display: flex;
    align-items: center;
  `,
  InputLabel: styled(InputLabel)<{ $center?: boolean }>`
    transform: none !important;
    font-size: 16px;
    color: ${(p) => p.theme.colors.darkGrey};
    font-weight: 400;
    ${(p) => (p.$center ? `width: 100%; right: none; text-align: center;` : ``)}
  `,
  BottomText: styled(Typography).attrs({ variant: "body1" })`
    text-align: start;
    font-size: 15px;
    margin-top: -23px;
    color: ${(p) => p.theme.colors.marbleGrey};
  `,
  SvgImg: styled.img`
    width: 24px;
    height: 24px;
  `,
}
// type options for autoComplete
type AutoCompleteOptions =
  | "name"
  | "tel-national"
  | "tel-local"
  | "tel-local-prefix"
  | "email"
  | "honorific-prefix"
  | "given-name"
  | "additional-name"
  | "family-name"
  | "honorific-suffix"
  | "nickname"
  | "username"
  | "new-password"
  | "current-password"
  | "one-time-code"
  | "organization-title"
  | "organization"
  | "street-address"
  | "address-line1"
  | "address-line2"
  | "address-line3"
  | "address-level4"
  | "address-level3"
  | "address-level2"
  | "address-level1"
  | "country"
  | "country-name"
  | "postal-code"
  | "cc-name"
  | "cc-given-name"
  | "cc-additional-name"
  | "cc-family-name"
  | "cc-number"
  | "cc-exp"
  | "cc-exp-month"
  | "cc-exp-year"
  | "cc-csc"
  | "cc-type"
  | "transaction-currency"
  | "transaction-amount"
  | "language"
  | "bday"
  | "bday-day"
  | "bday-month"
  | "bday-year"
  | "sex"
  | "url"
  | "photo"
  | "one-time-code"
  | ""

export interface CommonInputProps extends BaseTextFieldProps {
  name: string
  label: string
  type?: "text" | "email" | "tel" | "number" | "date"
  required?: boolean
  maxLength?: number
  placeholder?: string
  numericKeyBoard?: boolean
  InputProps?: InputBaseProps
  // bottomText?: string
  centerField?: boolean
  autoFocus?: boolean
  autoComplete?: AutoCompleteOptions
  className?: string
  hideLabel?: boolean
  marginTop?: number
}

const FormInput = ({
  name,
  label,
  type = "text",
  required = false,
  placeholder,
  maxLength,
  numericKeyBoard,
  InputProps,
  // bottomText,
  centerField,
  autoFocus,
  className,
  hideLabel,
  marginTop,
  ...props
}: CommonInputProps) => {
  // const [field, { error, touched }] = useField(name)
  const [field] = useField(name)
  return (
    <FormControl>
      <Styled.FieldWrapper $marginTop={marginTop}>
        <FormikInput
          name={name}
          label={label}
          type={numericKeyBoard ? "tel" : type}
          required={required}
          placeholder={placeholder}
          maxLength={maxLength}
          numeric={numericKeyBoard}
          centerField={centerField}
          InputProps={InputProps}
          autoFocus={autoFocus}
          className={className}
          hideLabel={hideLabel}
          {...field}
          {...props}
        />
      </Styled.FieldWrapper>
    </FormControl>
  )
}

export default FormInput
